export const workEnvironment = {
  junior: {
    macos: [
      { step: 'Install Chrome', command: 'brew install --cask google-chrome' },
      { step: 'Install Slack', command: 'brew install --cask slack' },
      { step: 'Install Zoom', command: 'brew install --cask zoom' },
      { step: 'Install Figma', command: 'brew install --cask figma' },
      { step: 'Install Notion', command: 'brew install --cask notion' },
      { step: 'Install Loom', command: 'brew install --cask loom' },
      { step: 'Install UserTesting', command: 'Web-based platform - bookmark in browser' }
    ],
    windows: [
      { step: 'Install Chrome', command: 'choco install googlechrome' },
      { step: 'Install Slack', command: 'choco install slack' },
      { step: 'Install Zoom', command: 'choco install zoom' },
      { step: 'Install Figma', command: 'choco install figma' },
      { step: 'Install Microsoft Office', command: 'choco install office365business' },
      { step: 'Install Teams', command: 'choco install microsoft-teams' },
      { step: 'Install Forms', command: 'Web-based platform - bookmark in browser' }
    ],
    linux: [
      { step: 'Install Chrome', command: 'wget -q -O - https://dl.google.com/linux/linux_signing_key.pub | sudo apt-key add - && echo "deb [arch=amd64] http://dl.google.com/linux/chrome/deb/ stable main" | sudo tee /etc/apt/sources.list.d/google-chrome.list && sudo apt update && sudo apt install google-chrome-stable' },
      { step: 'Install Slack', command: 'sudo snap install slack --classic' },
      { step: 'Install Zoom', command: 'sudo snap install zoom-client' },
      { step: 'Install LibreOffice', command: 'sudo apt install libreoffice' },
      { step: 'Install R', command: 'sudo apt install r-base' },
      { step: 'Install Python', command: 'sudo apt install python3 python3-pip' },
      { step: 'Install Jupyter', command: 'pip3 install jupyter pandas matplotlib seaborn' }
    ]
  },
  mid: {
    macos: [
      { step: 'Install Maze', command: 'Web-based usability testing platform' },
      { step: 'Install Hotjar', command: 'Web-based heatmap and analytics platform' },
      { step: 'Install Amplitude', command: 'Web-based product analytics platform' },
      { step: 'Install Dovetail', command: 'Web-based research repository platform' },
      { step: 'Install Airtable', command: 'brew install --cask airtable' },
      { step: 'Install Miro', command: 'brew install --cask miro' }
    ],
    windows: [
      { step: 'Install Power BI Desktop', command: 'choco install powerbi' },
      { step: 'Install Excel Advanced', command: 'Configure advanced Excel features for data analysis' },
      { step: 'Install SPSS', command: 'Statistical analysis software installation' },
      { step: 'Install Tableau', command: 'choco install tableau-desktop' },
      { step: 'Install Azure Analytics', command: 'Web-based platform configuration' }
    ],
    linux: [
      { step: 'Install Advanced Python Stack', command: 'pip3 install scikit-learn scipy statsmodels plotly dash streamlit' },
      { step: 'Install PostgreSQL', command: 'sudo apt install postgresql postgresql-contrib' },
      { step: 'Install Docker', command: 'curl -fsSL https://get.docker.com -o get-docker.sh && sh get-docker.sh' },
      { step: 'Install Jupyter Lab', command: 'pip3 install jupyterlab' },
      { step: 'Install RStudio', command: 'sudo apt install r-base && wget https://download1.rstudio.org/desktop/bionic/amd64/rstudio-2023.12.1-402-amd64.deb && sudo dpkg -i rstudio-*.deb' }
    ]
  },
  senior: {
    macos: [
      { step: 'Install Research Operations Suite', command: 'Configure enterprise research management tools' },
      { step: 'Install Advanced Analytics Tools', command: 'Set up machine learning and AI research platforms' },
      { step: 'Install Research Repository Systems', command: 'Configure enterprise research knowledge management' },
      { step: 'Install Automated Research Tools', command: 'Set up research automation and workflow tools' }
    ],
    windows: [
      { step: 'Install Advanced Power Platform', command: 'Configure Power Platform for research automation' },
      { step: 'Install Azure Cognitive Services', command: 'Set up AI-powered research analysis tools' },
      { step: 'Install Advanced Analytics Suite', command: 'Configure enterprise analytics and BI tools' },
      { step: 'Install Research Management Platform', command: 'Set up enterprise research operations tools' }
    ],
    linux: [
      { step: 'Install Machine Learning Stack', command: 'pip3 install tensorflow pytorch transformers nltk spacy' },
      { step: 'Install Big Data Tools', command: 'Install Apache Spark, Hadoop ecosystem for large-scale analysis' },
      { step: 'Install Research Automation', command: 'pip3 install selenium beautifulsoup4 scrapy airflow' },
      { step: 'Install Advanced Visualization', command: 'pip3 install bokeh altair plotly-dash d3py' }
    ]
  }
};
